import { render, staticRenderFns } from "./failReason.vue?vue&type=template&id=485643f6&scoped=true&"
import script from "./failReason.vue?vue&type=script&lang=js&"
export * from "./failReason.vue?vue&type=script&lang=js&"
import style0 from "./failReason.vue?vue&type=style&index=0&id=485643f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485643f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('485643f6')) {
      api.createRecord('485643f6', component.options)
    } else {
      api.reload('485643f6', component.options)
    }
    module.hot.accept("./failReason.vue?vue&type=template&id=485643f6&scoped=true&", function () {
      api.rerender('485643f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/clue/clueManage/detail/failReason.vue"
export default component.exports